import { ICustomFieldDfn } from '.';
import { IEntity } from './Entity';

export interface ICustomField extends IEntity {
    ID: number;
    CustomFieldDefnID: number | null;
    CustomFieldValue: string;
    BenefitID: number | null;
    CommitmentID: number | null;
    DependencyID: number | null;
    KeyWorkAreaID: number | null;
    MetricID: number | null;
    MilestoneID: number | null;
    WorkStreamID: number | null;
    CustomFieldDfn?: ICustomFieldDfn | null;
    RiskID: number | null;
    PartnerOrganisationRiskID: number | null;
    DirectorateID: number | null;
    ProjectID: number | null;
    App03TaskID: number | null;
}

export class CustomField implements ICustomField {
    public ID = 0;
    public Title = null;
    public CustomFieldDefnID = null;
    public CustomFieldValue = '';
    public BenefitID = null;
    public CommitmentID = null;
    public DependencyID = null;
    public KeyWorkAreaID = null;
    public MetricID = null;
    public MilestoneID = null;
    public WorkStreamID = null;
    public CustomFieldDfn = null;
    public RiskID = null;
    public PartnerOrganisationRiskID = null;
    public DirectorateID = null;
    public ProjectID = null;
    public App03TaskID = null;
}